import { Measure } from './AbstractMeasure';

export class Temperature extends Measure {
  constructor(
    measureList: Array<number>,
    dateList: Array<Date>,
    assetId: string,
    type: string,
    reference: string
  ) {
    super(measureList, dateList, assetId, type, reference);
  }
}
